import React, {useEffect, useState} from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ProductService from "@/modules/front/services/ProductService";
import VariantSelector from "@/modules/front/VariantSelector";

export const addProductsToCart = (productIds, dateFrom, dateTo, officeId) => {
    let urlApi = new URL(window.links.reservation.addToCartJson);
    urlApi.searchParams.append('dateFrom', dateFrom);
    urlApi.searchParams.append('dateTo', dateTo);
    urlApi.searchParams.append('productId', productIds.join(','));
    urlApi.searchParams.append('officeId', officeId ?? 1);

    return fetch(urlApi.toString(), {
        method: 'GET',
    })
        .then(response => {
            if (!response.ok) {
                throw new Error('HTTP ' + response.status);
            }
            return response.json();
        })
        .catch((error) => {
            console.error(error);
            return {success: false, error: 'Nepodařilo se přidat do košíku, zkuste to prosím znovu.'};
        })
        .then(data => {
            if (data.success) {
                window.location.href = window.links.reservation.finish;
            } else {
                alert(data.error);
            }
            return data;
        });
}

// API může při chybě vrátit JSON s chybou místo seznamu – bereme jen položky s produktem
const normalizeRecommendedItems = (data) => {
    if (!data || typeof data !== 'object' || data.error) {
        return [];
    }
    return Object.keys(data).map((key) => data[key]).filter((item) => item && item.product);
}

export const AddToCartModal = ({
                                   recommendedProducts,
                                   dateFrom, dateTo,
                                   productId,
                                   officeId,
                                   ...props
                               }) => {

    const handleClose = () => {
        props.onHide();
    }

    const [loading, setLoading] = useState(true);
    const [recommendedItems, setRecommendedItems] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [submitting, setSubmitting] = useState(false);

    console.log(selectedIds);

    const submit = (productIds) => {
        setSubmitting(true);
        return addProductsToCart(productIds, dateFrom, dateTo, officeId).then((data) => {
            if (!data.success) {
                setSubmitting(false);
            }
            return data;
        });
    }

    useEffect(() => {
        ProductService.getRecommendedItems(productId, dateFrom, dateTo, 'addToCartModal')
            .then(normalizeRecommendedItems)
            .catch(() => [])
            .then((items) => {
                if (items.length === 0) {
                    // bez doporučených produktů nemá smysl nic nabízet – přidáme rovnou do košíku
                    // při úspěchu necháme točit spinner až do přesměrování na košík
                    return submit([productId]).then((data) => {
                        if (!data.success) {
                            setLoading(false);
                        }
                    });
                }
                setRecommendedItems(items);
                setLoading(false);
            });
    }, []);


    let items = recommendedItems.map((item, index) => {
        return recommendedItems[index];
    });

    console.log(items, '35');

    let itemsGrouped = [];
    for (let i = 0; i < items.length; i++) {
        if (items[i].product.subri_variant_of) {
            if (!itemsGrouped[items[i].product.subri_variant_of]) {
                itemsGrouped[items[i].product.subri_variant_of] = {
                    variants: [],
                    product: items[i].product,
                    image: items[i].image
                };
            }
            itemsGrouped[items[i].product.subri_variant_of].variants.push(items[i]);
        } else {
            itemsGrouped[items[i].product.id] = items[i];
        }
    }

    let itemsElements = [];
    for (let i = 0; i < itemsGrouped.length; i++) {
        itemsElements[i] =
            <RecommendationItem item={itemsGrouped[i]} index={i} onChange={(checked, productId, toUncheckIds) => {
                let ids = selectedIds;
                ids = ids.filter((id) => !toUncheckIds.includes(id));
                if (checked) {
                    ids.push(productId);

                }
                setSelectedIds(ids);
            }}/>
    }


    const handleSubmit = () => {
        if (submitting) {
            return;
        }
        submit([productId, ...selectedIds]);
    }

    return (
        <>
            <Modal
                show={props.show}
                size={'lg'}
                onHide={handleClose}
                centered={true}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Přidat do košíku</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading
                        ? <div className="text-center py-4"><span className="spinner-border" role="status" aria-hidden="true"></span></div>
                        : (itemsElements.length ? itemsElements : 'Produkt se nepodařilo přidat do košíku.')}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Zavřít
                    </Button>

                    <Button variant="primary" disabled={loading || submitting} onClick={handleSubmit}>Přidat do košíku {submitting ? <i className="fa fa-spinner fa-spin"></i> : ''}</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const RecommendationItem = ({item, index, onChange}) => {
    if (!item) {
        return null;
    }

    const [checked, setChecked] = useState(false);
    const [productId, setProductId] = useState(item.product.id);
    const [didMount, setDidMount] = useState(false);

    useEffect(() => {
        setDidMount(true);

    }, []);

    useEffect(() => {
        let toUncheck = [productId];
        toUncheck.push(...item.variants.map((variant) => variant.product.id));

        onChange(checked, productId, toUncheck);

    }, [checked, productId]);

    useEffect(() => {
        if (didMount) {
            setChecked(true);
        }

    }, [productId]);


    let mainTitle = item.product.parentTitle ? item.product.parentTitle : item.product.title;
    const unavailable = item.availableQuantity != null && item.availableQuantity <= 0;

    return (
        <div key={index}
             className={'d-flex align-items-center border border-2 my-2 p-3' + (unavailable ? ' item-unavailable opacity-50' : ' cursor-pointer') + (checked && !unavailable ? ' border-primary' : '')}>
            <div onClick={() => !unavailable && setChecked(!checked)}>
                <input type="checkbox" checked={checked} disabled={unavailable} onChange={() => setChecked(!checked)}/>
            </div>
            <div className='me-3' onClick={() => !unavailable && setChecked(!checked)}>
                <img src={item.image} alt={mainTitle} width={50}/>
            </div>
            <div>
                <div className={'d-flex align-items-center'}>
                <a className={'me-3 text-black text-decoration-none' + (unavailable ? '' : ' cursor-pointer')} onClick={() => !unavailable && setChecked(!checked)} style={{cursor: unavailable ? 'default' : 'pointer'}}>
                    {mainTitle}
                </a>
                <VariantSelector variants={item.variants.map(
                    (variant) => {
                        return {
                            id: variant.product.id,
                            title: variant.product.title
                        }
                    }
                )} onVariantChange={(variant) => {
                    setProductId(variant);
                }}/>
                </div>
                {item.availableQuantity != null && <div className="item-available-quantity small text-muted mt-1">Dostupný počet: {item.availableQuantity}</div>}
            </div>
        </div>
    );
}